import { registerApplication, start } from "single-spa";
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine,
} from "single-spa-layout";
import microfrontendLayout from "./microfrontend-layout.html";
import { setCanonicalURL, addAlternateLinks } from "./utils/seoLinks";

const loaderUI = `<div class="spinner"></div>`;

const getChatbotProps = () => {
  const pathParts = window.location.pathname.split("/");
  const homeMarket = pathParts[2]; // Get the homeMarket parameter

  return {
    configProfile: homeMarket,
    environment: process.env.SKY_APP_CHATBOT_ENVIRONMENT || "development",
  };
};

const data = {
  loaders: {
    loadingSpin: loaderUI,
  },
  props: {
    getChatbotProps,
  },
};

const routes = constructRoutes(microfrontendLayout, data);

const applications = constructApplications({
  routes,
  loadApp({ name }) {
    return System.import(name);
  },
});
const layoutEngine = constructLayoutEngine({ routes, applications });

setCanonicalURL();
addAlternateLinks();
applications.forEach(registerApplication);
layoutEngine.activate();
start();
